import { render, staticRenderFns } from "./data-ready-set.vue?vue&type=template&id=63b448ca&scoped=true&"
import script from "./data-ready-set.vue?vue&type=script&lang=js&"
export * from "./data-ready-set.vue?vue&type=script&lang=js&"
import style0 from "./data-ready-set.vue?vue&type=style&index=0&id=63b448ca&scoped=true&lang=css&"
import style1 from "./data-ready-set.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b448ca",
  null
  
)

export default component.exports